import { CloseOutlined } from "@ant-design/icons"
import { Button, Col, Input, Modal, Row, Select } from "antd"
import { error_manager } from "helper/error_manager"
import { get, post } from "helper/request"
import { Component } from "react"
import { connect } from "react-redux"
import { getCaseIdPlaceholder } from "utils/org_utils"

import "asset/style/dashboard.css"
import "asset/style/style.css"


class AddCasesToFolderModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            "suggestions": [],
            "selected": [],
        }

        this.debounceTimeout = true
        this.debouceTimeInterval = 500 //ms
    }

    typeAheadSearch = (prefix) => {
        if (this.debounceTimeout !== null) this.clearSuggestionsTimeout()
        this.debounceTimeout = setTimeout(() => this.fetchSuggestions(prefix), this.debouceTimeInterval)
    }

    fetchSuggestions = (prefix) => {
        if (!prefix) return
        const url = "/api/search_cases_by_id/"
        get(url)
            .then(data => this.setState({ suggestions: data["suggestions"] }))
            .catch(err => console.error(err.message))
            .finally(() => this.clearSuggestionsTimeout())
    }

    clearSuggestionsTimeout = () => {
        clearTimeout(this.debounceTimeout)
        this.debounceTimeout = null
    }

    selectCase = (selectedValue) => {
        this.setState(state => ({
            ...state,
            selected: state.selected.includes(selectedValue) ? state.selected : [...state.selected, selectedValue]
        }))
    }

    deselectCase = (value) => {
        this.setState(state => ({
            ...state,
            selected: state.selected.filter(v => v !== value)
        }))
    }

    handleAddCases = () => {
        const url = "/api/update_cases_in_folder/"

        const data = {
            folder_id: this.props.folderId,
            case_ids: this.state.selected,
            action: "add",
        }

        post(url, data)
            .then(() => this.props.closeModal())
            .catch(err => error_manager("unable to add cases", err))
            .finally(() => window.location.reload())
    }

    render() {
        return (
            <Modal
                title={"Add Cases to Folder"}
                visible={this.props.showModal}
                onCancel={this.props.closeModal}
                onOk={this.handleAddCases}
                okButtonProps={{ disabled: (this.state.selected.length < 1) }}
            >
                <Row type="flex" gutter={[0, 16]}>
                    <Col span={24}>
                        Case Selected: {this.state.selected.length}
                    </Col>
                    <Col span={24}>
                        <div className="scroll-slide-list-modal">
                            <Row type="flex" gutter={[0, 16]}>
                                {this.state.selected.map(s => (
                                    <Col span={20}>
                                        <Row key={s} type="flex" justify="space-around" align="middle">
                                            <Col span={14} offset={3}>
                                                <Input
                                                    value={s}
                                                    style={{ color: "black", cursor: "default" }}
                                                    disabled
                                                />
                                            </Col>
                                            <Col span={6} offset={1}>
                                                <Button
                                                    type="danger"
                                                    ghost
                                                    size="small"
                                                    onClick={() => this.deselectCase(s)}
                                                >
                                                    <CloseOutlined />
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Col>
                    <Col>
                        Please Enter {getCaseIdPlaceholder()} in the input box below
                    </Col>
                    <Col span={24}>
                        <Select
                            showSearch
                            allowClear
                            autoFocus
                            placeholder={`Enter ${getCaseIdPlaceholder()}`}
                            className="search-input"
                            showArrow={false}
                            filterOption={false}
                            notFoundContent={null}
                            onSearch={this.typeAheadSearch}
                            onSelect={this.selectCase}
                            optionLabelProp="label"
                            value={this.state.selected}
                        >
                            {this.state.suggestions?.map(({ case_id }, idx) => (
                                <Select.Option
                                    key={idx}
                                    value={case_id}
                                    className="search-result-tag"
                                    size="small"
                                    type="tag"
                                >
                                    {case_id}
                                </Select.Option>
                            )) || []
                            }
                        </Select>
                    </Col>
                </Row>
            </Modal>
        )
    }
}


const mapStateToProps = () => ({
})

export default connect(mapStateToProps)(AddCasesToFolderModal)